import { Fragment } from "react";
import { Box, Divider, Typography } from "@material-ui/core";

import { AmcHeader, SubTotal, TransactionHeader } from "./CartItems";
import CustomButton from "../../forms/CustomButton";
import useInvestorCart, {
  CART_ITEMS_MAP,
  FundItemsProps,
  MAXIMUM_CART_ITEMS,
} from "./useInvestorCart";
import { Info } from "../customModal";

export const DetailedInvestorCart = () => {
  const {
    fundCodes,
    getFundDesc,
    investorName,
    cartItems,
    mappedCartItems,
    pan,
    removeCartItem,
    selectCartItem,
    editCartItem,
    selected,
    transactionType,
    checkoutCart,
    addNewTransaction,
    transactionName,
    isKYCInvalid,
    message,
  } = useInvestorCart();

  return (
    <Fragment>
      <InvestorHeader name={investorName} pan={pan} />
      <Box
        sx={{
          margin: "40px",
          bgcolor: "white",
          padding: "18px 24px 18px 24px",
          boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
          borderRadius: "4px",
          marginBottom: "120px",
        }}
      >
        <TransactionHeader trType={transactionName} />

        {fundCodes.map((fundCode) => {
          const fundCartItems = mappedCartItems[fundCode];
          const isAmount = fundCartItems.every((item) => !item.units);
          const subTotal = fundCartItems
            .filter(
              (amcItem) =>
                selected.findIndex((s) => amcItem.cartItemId === s) !== -1
            )
            .reduce((acc, { payload }) => {
              if ("installmentAmount" in payload) {
                return (
                  Number(acc) +
                  Number(payload.amount) +
                  Number(payload.installmentAmount)
                );
              }
              return Number(acc) + Number(payload.amount);
            }, 0);
          const selectedFundCartItems = fundCartItems.filter((item) =>
            selected.includes(item.cartItemId)
          );

          const displayAmount =
            transactionType === "STP"
              ? // @ts-ignore
                fundCartItems.some((item) => item.payload.stpOption === "Fixed")
              : transactionType === "SWP"
              ? // @ts-ignore
                fundCartItems.some((item) => item.payload.swpOption === "Fixed")
              : true;

          return (
            <Fragment key={fundCode}>
              <AmcHeader amcName={getFundDesc(fundCode)} />
              <FundItems
                removeCartItem={removeCartItem}
                selectCartItem={selectCartItem}
                selected={selected}
                fundCode={fundCode}
                fundCartItems={mappedCartItems[fundCode]}
                editCartItem={editCartItem}
                transactionType={transactionType}
                newPurchaseSipType={cartItems[0].payload.newPurchaseSipType}
              />
              {isAmount && displayAmount ? (
                <Box bgcolor="rgba(0, 124, 197, 0.03)">
                  <SubTotal
                    amount={subTotal}
                    count={selectedFundCartItems.length}
                  />
                </Box>
              ) : (
                <Box sx={{ marginBottom: 30 }} />
              )}
            </Fragment>
          );
        })}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CustomButton
            variant="outlined"
            label="Add Another Transaction"
            onClick={addNewTransaction}
            disabled={cartItems.length === MAXIMUM_CART_ITEMS}
          />
          <CustomButton
            label="Checkout"
            variant="contained"
            onClick={checkoutCart}
            disabled={selected.length === 0}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Info display={isKYCInvalid} message={message} />
        </Box>
      </Box>
    </Fragment>
  );
};

export const InvestorHeader = (props: { name: string; pan: string }) => (
  <Box
    display={"flex"}
    sx={{
      margin: "40px",
      bgcolor: "white",
      padding: "18px 24px 18px 24px",
      boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
      borderRadius: "4px",
    }}
  >
    <Typography
      style={{
        color: "#919191",
        fontWeight: "600",
        marginRight: "5px",
        fontSize: "14px",
      }}
    >
      Investor:
    </Typography>

    <Typography style={{ fontWeight: "500", fontSize: "15px" }}>
      {props.name}
    </Typography>
    <Typography
      style={{
        color: "#919191",
        fontWeight: "500",
        marginRight: "5px",
        marginLeft: "20px",
        fontSize: "14px",
      }}
    >
      PAN:
    </Typography>

    <Typography style={{ fontWeight: "500", fontSize: "15px" }}>
      {props.pan}
    </Typography>
  </Box>
);

const FundItems: FundItemsProps = function (props) {
  const {
    fundCartItems,
    removeCartItem,
    selectCartItem,
    editCartItem,
    selected,
    fundCode,
    transactionType,
    newPurchaseSipType,
  } = props;

  const { cartComponent: component } =
    CART_ITEMS_MAP(newPurchaseSipType)[transactionType];

  if (typeof component === "string") {
    return <div />;
  }

  return (
    <Fragment>
      {fundCartItems.map(({ cartId, cartItemId, payload }, itemIndex) => {
        return (
          <Box key={cartItemId}>
            <Box
              sx={{
                padding: "10px",
                border: "0.5px solid #C7D2D4",
              }}
            >
              <Box padding={"10px"}>
                {component({
                  cartItemId,
                  cartId,
                  removeCartItem,
                  selectCartItem,
                  isSelected: selected.includes(cartItemId),
                  editCartItem,
                  fundCode,
                  // @ts-ignore
                  payload,
                })}
                {/* @ts-ignore */}
                {payload.isDateRefresh && (
                  <Typography>
                    Start and End dates for your Systematic Transaction have
                    been changed, Please verify.
                  </Typography>
                )}
                {itemIndex !== fundCartItems.length - 1 && (
                  <Divider variant="middle" />
                )}
              </Box>
            </Box>
          </Box>
        );
      })}
    </Fragment>
  );
};
